// components/auth/AuthCallback.tsx
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AuthCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { checkAuthStatus, user, loading } = useAuth();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const handleCallback = async (): Promise<void> => {
      try {
        const urlParams = new URLSearchParams(location.search);
        const token = urlParams.get('token');

        if (token) {
          
          // Store token
          localStorage.setItem('token', token);
          
          // Update auth context and wait for it to complete
          await checkAuthStatus();
        } else {
          console.error('AuthCallback: No token found in callback URL');
          navigate('/signin', { replace: true });
        }
      } catch (error) {
        console.error('AuthCallback: Error during callback handling:', error);
        navigate('/signin', { replace: true });
      } finally {
        setProcessing(false);
      }
    };

    handleCallback();
  }, [location, checkAuthStatus, navigate]);

  // Handle navigation after user state is updated
  useEffect(() => {
    if (!processing && !loading && user) {
      
      // Check for stored redirect destination
      const storedRedirect = sessionStorage.getItem('authRedirect');
      if (storedRedirect) {
        sessionStorage.removeItem('authRedirect');
        
        // ✅ FIXED: Validate redirect destination based on user role
        if (user.role === 'admin' && storedRedirect.startsWith('/admin')) {
          navigate(storedRedirect, { replace: true });
          return;
        } else if (user.role === 'user' && storedRedirect.startsWith('/dashboard')) {
          navigate(storedRedirect, { replace: true });
          return;
        }
      }
      
      // ✅ FIXED: Default redirection based on role (no cross-role access)
      const defaultPath = user.role === 'admin' ? '/admin' : '/dashboard';
      navigate(defaultPath, { replace: true });
    } else if (!processing && !loading && !user) {
      navigate('/signin', { replace: true });
    }
  }, [user, loading, processing, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-accent">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#00088E] mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-400">
          Traitement de l'authentification...
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;